import {
  AfterContentChecked,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output, ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable, of} from 'rxjs';

import {FlowManagerService} from '../../../services/flow-manager.service';
import {catchError, map, shareReplay, startWith, tap} from 'rxjs/operators';

import {FlowMetaData} from '../../../../../shared/models/flow-meta-data';
import {FlowBuilderService} from '../../../services/flowBuilder/flow-builder.service';
import {NodeDetails} from '../../../services/flowBuilder/models';
import {FlowStepTypes} from '../../../services/flowBuilder/utils/flow-step-types.enum';
import find from 'lodash/find';
import { SharedService } from '../../../../../core/services/store/shared-store/shared-storage.service';
import {Store} from "@ngrx/store";
import {selectNodeTypesMap} from "../../../../../core/state/selectors/flow.selector";

@Component({
  selector: 'next-selector',
  templateUrl: './next-selector.component.html',
  styleUrls: ['./next-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NextSelectorComponent implements OnInit, AfterContentChecked {
  @Input() name: string;
  @Input() form: FormGroup;
  @Input() noNewStep = false;
  @Input() flowSteps: Array<string>;
  @Input() selectedValue;
  @Input() selectorType: NextSelectorType;
  @Input() flows: object;
  @Input() canEditFlows: boolean;
  @Input() from: string;
  @Input() botId: string;
  @Input() stepId: string;
  @Input() disableFlowFilter = false;

  @Input() isOptional: boolean = false;

  @Output() focus = new EventEmitter();
  @Output() onNextStepError = new EventEmitter();
  // @Output() openFlowStepSelectionModal = new EventEmitter();

  flowForm = new FormGroup({
    flow: new FormControl(''),
    step: new FormControl(''),
  });



  _selection = 'step';

  // @ViewChild('selection') _selection;

  _flow: any = '';
  _step: String = 'start';
  private step: string;
  _steps: Observable<string[]>;
  _flowNames: Observable<FlowMetaData[]>;
  _flowSteps: Observable<string[]>;
  stepDisabled: boolean;
  flowMetadata: any;

  allStepData;
  stepOptions: NodeDetails[];
  filteredOptions: Observable<NodeDetails[]>;
  allNodeTypes;
  selectedFlow: any;
  selectedFlowName: any;
  filteredOptionsLength: number;

  showFlowStepSelectionModal: boolean = false;
  flowStepSelectionValue: any = undefined;


  @ViewChild('stepSelected') stepInput: ElementRef;
  @ViewChild('autoComplete') autocomplete;
  selectedClientNameIndex: number;
  public currentFlow: any;

  get isValid() {
    return this.form.controls[this.name].valid;
  }

  get isDirty() {
    return this.form.controls[this.name].dirty;
  }

  constructor(
    private flowManagerService: FlowManagerService,
    private sharedService: SharedService,
    private flowBuilderService: FlowBuilderService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.currentFlow = this.flowBuilderService.getFlow();
    if (!this.from) {
        this.from = 'node';
    }
    this.selectorType = this.selectorType ? this.selectorType : 'both';
    // this._selection = this.selectorType === 'flow';
    const formValue: string = this.form.get(this.name).value;
    const index = formValue.indexOf(':');
    this._steps = of(this.flowSteps);
    // if index is on -1 meaning its a flow not a step;
    if (index !== -1) {
      this._flow = formValue.substring(0, index);
      this._step = formValue.substring(index + 1);
      this._selection = 'flow';
      this.getFlowNames();

      if (this.flows) {
        let flowId = '';
        if (this.flows.hasOwnProperty(this._flow)) {
          flowId = this._flow;
        } else {
            // this._flow = 'Select a flow';
            this.form.get(this.name).setErrors({'validFlowId': 'Please select a valid flow'});
        }
        this.getSteps(flowId);
      }
    } else if (this.selectorType === 'flow') {
      this.getFlowNames();
    } else {
      this.step = formValue;
    }

    this.filteredOptions = this.form.get(this.name).valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value)),
        tap(val => {
          this.filteredOptionsLength = val.length;
        })
    );
    this.allStepData = this.flowBuilderService.getAllStepsDetails;

    if (!Object.keys(this.allStepData).includes('NextStep') && !this.noNewStep) {
      this.allStepData['NextStep'] = new NodeDetails('', FlowStepTypes.NEW, 'new', 'NextStep', null, '');
    }
    if (this.isOptional) {
      this.allStepData['OPTIONAL'] = new NodeDetails('', FlowStepTypes.NEW, 'new', 'OPTIONAL', null, '');
    }
    this.stepOptions = Object.values(this.allStepData);
    this.disableStepSelection();
    this.allNodeTypes = this.store.select(selectNodeTypesMap);

    if (this.stepId) {
      const { next } = this.currentFlow[this.stepId];
      if (next && this.step === 'NextStep') {
        this.form.get(this.name).setValue(next);
      }
    }

    if (this.stepId && this.step === 'NextStep') {
      const { action } = this.currentFlow[this.stepId];
      if (action && action.actionType === 'chatHub') {
        this.form.get(this.name).setValue(action.result[this.name]);
      }
    }
  }

  ngAfterContentChecked() {
    this.setSelectedFlow();
  }

  modifyNextStepFormValue(value: string) {
    let modifiedValue = '';
    switch (value) {
      case 'NextStep':
      case 'newStep':
        modifiedValue = 'New Step';
        break;
      case 'Next Step':
      case 'New Step':
        modifiedValue = 'NextStep';
        break;
      case 'start':
        modifiedValue = 'Start';
        break;
      case 'OPTIONAL':
        modifiedValue = 'OPTIONAL';
        break;
      default:
        if (value.includes('Step')) {
          modifiedValue = value.charAt(0).toLowerCase() + value.substring(1, value.length);
          modifiedValue = modifiedValue.replace(' ', '');
        } else if (value.includes('step')) {
          modifiedValue = value.charAt(0).toUpperCase() + value.substring(1, value.length);
          modifiedValue = modifiedValue.substring(0, 4) + ' ' + modifiedValue.substring(4);
        }
        break;
    }
    return modifiedValue;
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase().replace(' ', '');
    return this.stepOptionsMapper(this.stepOptions.filter(option => {
      if (option.stepType.toLowerCase().includes(filterValue)) {
        return true;
      }
      if (option.nodeType.toLowerCase().includes(filterValue)) {
        return true;
      }
      return option.nodeId.toLowerCase().includes(filterValue);
    }));
  }

  stepOptionsMapper(arr: Array<NodeDetails>): any[] {
    return arr.map(x => {
      switch (x.nodeId) {
        case 'newStep':
          return {
            label: 'New Step',
            value: x.nodeId
          };
        case 'NextStep':
          return {
            label: 'New Step',
            value: x.nodeId
          };
        case 'start':
          return {
            label: 'Start',
            value: x.nodeId
          };
        default:
          const label = x.nodeId.replace('step', 'Step ');
          return { label: label, value: x.nodeId };
      }
    });
  }

  onToggleNextStepSearchOpenClosed() {
    const img = document.querySelector('#flowImg');
    if (img.getAttribute('src') === '../../../../assets/svg/chevron-up.svg') {
      img.setAttribute('src', '../../../../assets/svg/redesign/chevron-down-medium.svg');
    } else {
      img.setAttribute('src', '../../../../assets/svg/chevron-up.svg');
      this.updateClientNameListPosition();
    }
  }

  updateClientNameListPosition() {
    this.updateSelectedIndex();
    const matOptionHeight = 48;
    const matOptionPosition = matOptionHeight * this.selectedClientNameIndex;
    setTimeout(() => {
      this.autocomplete.panel.nativeElement.scrollTop = matOptionPosition;
      this.highlightSelectedClientOption();
    }, 0);
  }

  highlightSelectedClientOption() {
    const elem = this.autocomplete.options._results[this.selectedClientNameIndex] as ElementRef;
    elem['_element'].nativeElement.classList.add('selected-client-option');
  }

  updateSelectedIndex() {
    this.stepOptions.filter((nodeDetail, nodeDetailIndex) => {
      if (nodeDetail.nodeId === this.form.get(this.name).value) {
        this.selectedClientNameIndex = nodeDetailIndex;
      }
    });
  }

  onNextStepOptionSelected(value: string) {
    this.selectedValue = value;
    this.stepInput.nativeElement.blur();
  }

  flowIdChange(val, param) {
    this[param] = val;
    if (param === '_flow') {
      this.getSteps(val);
    }

    this.isStepDisabled();
    if (this._flow) {
      const flowName = typeof this._flow === 'object' ? this._flow.flowName : this._flow;
      // console.log('form', this.form);
        if (this.flows.hasOwnProperty(flowName)) {
            this.form.controls[this.name].setValue(
                `${flowName}:${this._step ? this._step : '-Not Selected-'}`
            );
            this.onNextStepError.emit(false);
        } else {
            this._flow = 'Select a flow';
            this._step = 'Start';
            this.form.controls[this.name].setErrors({'validFlowId': 'Please select a valid flow'});
            this.onNextStepError.emit(true);
        }
    }
  }

  toggleChange(event: string) {
    this._selection = event;
    if (event === 'flow') {
      this.isStepDisabled();
      this.getFlowNames();
      this.openFlowStepSelectionModalHandler();
    } else {
      this._steps = of(this.flowSteps);
      this.selectedValue = this.step ? this.step : this.flowSteps[0];
      this.form.get(this.name).setValue('NextStep');
      this.selectedFlowName = "";
    }
  }

  private isStepDisabled() {
    this.stepDisabled = this._flow === '';
  }

  /**
   * Get all the flow name
   *
   * @function this.utils.getId()
   * gets the cashed client id
   *
   * @returns Observable<string[]>
   */
  getFlowNames() {
    this.flowMetadata = {};
    if (!this._flowNames) {
      this._flowNames = this.flowManagerService.getFlowMetaData(true).pipe(
        map((metaData: FlowMetaData[]) => {
          for (const meta of metaData) {
            this.flowMetadata[meta.flowId] = meta;
          }
          return metaData;
        }),
        shareReplay(1)
      );
    }
  }

  /**
   * Get all steps for a particular flow
   *
   * @param flowId
   *
   * @function this.utils.getId()
   * gets the cashed client id
   *
   * @returns Observable<string[]>
   */
  getSteps(flowId: string) {
    if (flowId) {
      this._flowSteps = this.flowManagerService.getFlowSteps(flowId).pipe(
        catchError((err) => {
            console.error('error', err);
          return of([]);
        }),
        shareReplay(1)
      );
    } else {
      this._flowSteps = of([]);
    }
  }

  onFocus(element: HTMLElement) {
    const focusElement = {
      name: this.name,
      element: element,
    };
    this.focus.emit(focusElement);
  }

  openFlowStepSelectionModalHandler() {
    // this.openFlowStepSelectionModal.emit({name: this.name, step: this.step});
    this.flowStepSelectionValue = {
      step: this.step,
      selected: this.form.get(this.name).value
    };
    this.showFlowStepSelectionModal = true;
  }

  setSelectedFlow() {
    const selectedValue = this.form.get(this.name).value;
    if (selectedValue) {
      const selectedValueArr = selectedValue.split(':');
      if (selectedValueArr && selectedValueArr.length === 2) {
        const flowId = selectedValueArr[0];
        return this.flowManagerService.getFlowMetaData().subscribe(data => {
          const selectedFlowData = find(data, { flowId });
          this.selectedFlow = selectedFlowData.directory.split('/');
          this.selectedFlowName = this.selectedFlow[this.selectedFlow.length - 1];
          this.selectedFlow.pop();
        });
      }
    }
  }

  getSelectedStep() {
    const selectedValue = this.form.get(this.name).value;
    if (selectedValue) {
      const selectedValueArr = selectedValue.split(':');
      let val = (selectedValueArr.length === 2) ? selectedValueArr[1] : selectedValueArr[0];
      if (val !== '-Not Selected-') {
        val = val.charAt(0).toUpperCase() + val.slice(1);
        if(val != 'Start'){
          val = val.substring(0, 4) + ' ' + val.substring(4, val.length);
        }
      }
      return val;
    }
  }

  disableStepSelection() {
    if (!this.canEditFlows) {
      this.form.get(this.name).disable();
    }
  }

  closeFlowStepSelectionModal(value: any) {
    this.showFlowStepSelectionModal = false;
    this.flowStepSelectionValue = {}
    if (value) {
      console.log(value)
      this.form.get(this.name).setValue(value);
    }
  }
}

export type NextSelectorType = 'flow' | 'step' | 'both';
